import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import NotFoundPage from './pages/NotFoundPage';


// ページコンポーネントのimport
import IndexPage from './pages/IndexPage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import OthersPage from './pages/OthersPage';
import DownloadsPage from './pages/DownloadsPage';


export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/others" element={<OthersPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}